<template>
  <div class="svg-icon" :class="{ 'shake-active': isActive }" :style="{ width: size, height: size }">
    <svg viewBox="0 0 1024 1024" v-if="iconName === '首页'">
      <path d="M467.387733 96.768L142.574933 383.317333a68.266667 68.266667 0 0 0-23.108266 51.2V887.466667a68.266667 68.266667 0 0 0 68.266666 68.266666h648.533334a68.266667 68.266667 0 0 0 68.266666-68.266666V434.466133a68.266667 68.266667 0 0 0-23.022933-51.114666L557.789867 96.836267a68.266667 68.266667 0 0 0-90.402134-0.085334zM187.733333 434.517333L512.546133 147.933867 836.266667 434.466133V887.466667H187.733333V434.517333z" :fill="isActive ? '#ff6b6b' : '#444444'"/>
      <path d="M546.133333 597.333333v221.866667h-68.266666V597.333333a34.133333 34.133333 0 1 1 68.266666 0z" fill="#00B386"/>
    </svg>

    <svg viewBox="0 0 1024 1024" v-if="iconName === '分类'">
      <path d="M476.7232 112.503467L121.634133 279.825067a68.266667 68.266667 0 0 0 1.6896 124.279466l355.089067 155.648a68.266667 68.266667 0 0 0 54.818133 0l355.089067-155.6992a68.266667 68.266667 0 0 0 1.672533-124.279466l-355.089066-167.253334a68.266667 68.266667 0 0 0-58.197334 0zM150.7328 341.572267l355.089067-167.304534 355.072 167.253334-355.089067 155.6992-355.072-155.648zM860.842667 685.346133a34.133333 34.133333 0 0 1 28.962133 61.781334l-2.4064 1.1264-368.810667 155.682133a34.133333 34.133333 0 0 1-23.671466 1.0752l-2.8672-1.0752-368.7936-155.648a34.133333 34.133333 0 0 1 24.064-63.829333l2.491733 0.938666 355.498667 150.050134 355.5328-150.101334z" :fill="isActive ? '#ff6b6b' : '#444444'"/>
      <path d="M853.333333 512l-341.486933 153.634133L170.666667 512.341333v55.210667c0 13.4656 7.748267 25.6512 19.712 30.9248l286.190933 126.976a78.7968 78.7968 0 0 0 35.2768 8.3968c12.049067 0 24.081067-2.798933 35.293867-8.3968l286.498133-127.249067A33.7408 33.7408 0 0 0 853.333333 567.278933V512z" fill="#00B386"/>
    </svg>

    <svg viewBox="0 0 1024 1024" v-if="iconName === '购物'">
      <path d="M95.2832 69.0176A34.133333 34.133333 0 0 1 135.168 92.791467l0.6144 2.474666 31.146667 145.954134h707.242666a68.266667 68.266667 0 0 1 68.181334 64.853333l0.085333 3.413333a68.266667 68.266667 0 0 1-1.962667 16.247467l-1.092266 3.9424-120.439467 388.693333a68.266667 68.266667 0 0 1-61.6448 47.9744l-3.566933 0.1024H264.4992a68.266667 68.266667 0 0 1-65.962667-50.688l-0.802133-3.328L69.0176 109.5168a34.133333 34.133333 0 0 1 26.2656-40.4992z m778.888533 240.469333H181.504l82.9952 388.693334h489.233067l120.439466-388.693334z" :fill="isActive ? '#ff6b6b' : '#444444'"/>
      <path d="M762.368 868.522667a51.2 51.2 0 1 1-102.4 0.017066 51.2 51.2 0 0 1 102.4 0M374.954667 868.522667a51.2 51.2 0 1 1-102.382934 0.017066 51.2 51.2 0 0 1 102.4 0" :fill="isActive ? '#ff6b6b' : '#444444'"/>
      <path d="M699.733333 563.2v34.133333a34.133333 34.133333 0 0 1-34.133333 34.133334H358.4a34.133333 34.133333 0 0 1-34.133333-34.133334v-34.133333h375.466666z" fill="#00B386"/>
    </svg>

    <svg viewBox="0 0 1024 1024" v-if="iconName === '我的'">
      <path d="M511.419733 68.266667C393.557333 68.266667 317.627733 117.9648 281.258667 201.7792c-23.261867 53.623467-27.306667 110.3872-21.896534 163.874133l0.682667 5.768534c6.519467 50.4832 32.1536 110.762667 68.864 154.555733l2.116267 2.474667L143.872 685.5168A68.266667 68.266667 0 0 0 119.466667 737.792v149.674667a68.266667 68.266667 0 0 0 68.266666 68.266666h648.533334a68.266667 68.266667 0 0 0 68.266666-68.266666v-149.623467l-0.119466-4.027733a68.266667 68.266667 0 0 0-24.405334-48.384L694.954667 531.012267l2.850133-3.1232c38.178133-43.485867 62.464-101.700267 70.485333-161.1264 7.236267-53.930667 2.167467-116.5312-23.517866-170.7008C706.56 115.421867 629.2992 68.266667 511.419733 68.266667z m0 68.266666c91.921067 0 144.9472 32.3584 171.6736 88.746667 19.114667 40.362667 23.176533 90.385067 17.527467 132.386133-7.901867 58.760533-36.1472 115.7632-77.943467 147.541334a34.133333 34.133333 0 0 0-1.211733 53.384533L836.266667 737.860267V887.466667H187.733333v-149.6576l216.064-181.282134a34.133333 34.133333 0 0 0-0.887466-53.009066c-39.133867-30.685867-70.775467-97.058133-75.605334-144.759467-4.352-42.888533-1.0752-89.122133 16.5888-129.809067C369.408 170.120533 420.693333 136.533333 511.419733 136.533333z" :fill="isActive ? '#ff6b6b' : '#444444'"/>
      <path d="M546.133333 648.533333v170.666667h-68.266666V648.533333a34.133333 34.133333 0 1 1 68.266666 0z" fill="#00B386"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconName: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '24px'
    },
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.svg-icon {
  display: inline-block;
}
.svg-icon svg {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

@keyframes shake {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(-5deg); }
  75% { transform: rotate(5deg); }
  100% { transform: rotate(0deg); }
}

.shake-active {
  animation: shake 0.3s ease-in-out;
  animation-iteration-count: 1;
  animation-play-state: running;
  animation-delay: 0s;
}

.shake-active:hover {
  animation: none;
}

/* 使用 CSS 动画来控制每3秒执行一次 */
@media (prefers-reduced-motion: no-preference) {
  .shake-active {
    animation: shake 0.3s ease-in-out;
    animation-iteration-count: infinite;
    animation-delay: 3s;
    animation-direction: normal;
    animation-timing-function: ease-in-out;
    animation-play-state: running;
  }
}
</style> 